import React, { ReactNode, useState } from 'react';

import { ButtonBase } from '@material-ui/core';
import { alpha, makeStyles } from '@material-ui/core/styles';
import Viewer from 'react-viewer';

type ImageViewerProps = {
  src?: string;
  disabled?: boolean;
  children: ReactNode;
};

const useStyles = makeStyles(({ palette, shape, zIndex }) => ({
  button: {
    display: 'contents',
  },
  viewer: {
    position: 'absolute',
    zIndex: zIndex.tooltip + 1,
    '& > .react-viewer-mask': {
      backgroundColor: alpha(palette.background.default, 0.96),
    },
    '& > .react-viewer-canvas > img': {
      borderRadius: shape.borderRadius,
    },
  },
}));

function ImageViewer(props: ImageViewerProps) {
  const { src, disabled, children } = props;
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const toggleOpen = () => {
    if (src) setOpen(!open);
  };

  return (
    <>
      <ButtonBase
        className={classes.button}
        disabled={!src || disabled}
        onClick={toggleOpen}
        disableRipple
      >
        {children}
      </ButtonBase>

      <Viewer
        className={classes.viewer}
        visible={open}
        onClose={toggleOpen}
        onMaskClick={toggleOpen}
        images={[{ src: src || '' }]}
        disableKeyboardSupport
        downloadable={false}
        changeable={false}
        showTotal={false}
        drag={false}
        noImgDetails
        noNavbar
      />
    </>
  );
}

export default React.memo(ImageViewer);
